<template>
  <div class="device">
    <div class="layout" style="margin-top: 95px">
      <div class="device-setting">
        <div
          class="layout-header"
          ref="searchBox"
          style="
            background: transparent;
            padding: 16px;
            width: calc(100% - 0.875rem);
          "
        >
          <div style="padding: 16px; background: #fff">
            <div class="infor-layout-header mb20">
              <span class="title" @click="refreshAddress"
                >站点管理<span> {{ platformCode }}</span></span
              >
            </div>
            <w-searchs
              @onSearch="onSearch"
              @newSite="newSite"
              @onExport="showWdialog2"
              @multSet="multSet"
            />
          </div>
        </div>
        <div style="height: 138px"></div>

        <div class="m16 pagination-bg-white device">
          <w-table
            needSelection
            :height="tableViewHeight"
            :renderHeaderBySiteCeiling="renderHeaderBySiteCeiling"
            :renderHeaderBySiteId="renderHeaderBySiteId"
            v-show="checkUserAuth(3, 16)"
            v-loading.body="tableLoading"
            :data-list="tableData"
            :columns="staticData.users.columns"
            :pageNo="formData.pageNum"
            :pageSize="formData.pageSize"
            :total="total"
            :pageSizes="pageSizes"
            @pageNoChange="pageNoChange"
            @pageSizeChange="pageSizeChange"
            @selection-change="selectionChange"
          >
            <template slot-scope="props" slot="cell">
              <div v-if="props.column.label === '站点名称'">
                <div :class="{ red: !props.row.siteLat || !props.row.siteLon }">
                  {{ props.row.siteName }}
                </div>
              </div>
              <div v-else-if="props.column.label === '站点编号'">
                <div :class="{ red: !props.row.siteLat || !props.row.siteLon }">
                  {{ props.row.siteId }}
                </div>
              </div>
              <div v-else-if="props.column.label === '站点长度'">
                <div :class="{ red: !props.row.siteLat || !props.row.siteLon }">
                  {{ props.row.length }}
                </div>
              </div>
              <div v-else-if="props.column.label === '道钉数量'">
                <div
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                >
                  {{ props.row.siteCeiling }}
                </div>
              </div>
              <div v-else-if="props.column.label === '回收站点'">
                <div
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                >
                  {{ props.row.recycleSwitch == 1 ? "是" : "否" }}
                </div>
              </div>
              <div v-else-if="props.column.label === '调度响应时间'">
                <div>
                  {{
                    props.row.dispatchResponseMinute == -1
                      ? "-"
                      : props.row.dispatchResponseMinute + "分钟"
                  }}
                </div>
              </div>
              <div v-else-if="props.column.label === '可投放'">
                <div
                  :class="{
                    green: props.row.brandPutSwitch,
                  }"
                >
                  {{ props.row.brandPutSwitch == 1 ? "是" : "否" }}
                </div>
              </div>
              <div v-else-if="props.column.label === '区域属性'">
                <div
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                >
                  {{ props.row.majorSwitch == 1 ? "重点区域" : "一般区域" }}
                </div>
              </div>
              <div v-else-if="props.column.label === '道钉编号'">
                <div
                  class="table-line"
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  v-for="(item, index) in props.row.equipments"
                  :key="'equipmentNo' + index"
                >
                  {{ item.equipmentNo }}
                </div>
              </div>
              <div v-else-if="props.column.label === 'MAC地址'">
                <div
                  class="table-line"
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  v-for="item in props.row.equipments"
                  :key="item.equipmentMac"
                >
                  {{ item.equipmentMac }}
                </div>
              </div>
              <div v-else-if="props.column.label === '信号强度'">
                <div
                  class="table-line"
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  v-for="(item, index) in props.row.equipments"
                  :key="'equipmentSignal' + index"
                >
                  {{ item.equipmentSignal }}
                </div>
              </div>
              <div v-else-if="props.column.label === '电池电量'">
                <div
                  @click="onShowDialog(item, props.row)"
                  :class="{
                    blue: Number(item.equipmentPower) >= 10,
                    'red-r': Number(item.equipmentPower) < 10,
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  class="table-line cursor"
                  v-for="(item, index) in props.row.equipments"
                  :key="'equipmentPower' + index"
                >
                  {{ item.equipmentPower }}%
                </div>
              </div>
              <div v-else-if="props.column.label === '更新时间'">
                <div
                  class="table-line"
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  v-for="(item, index) in props.row.equipments"
                  :key="'updateTime' + index"
                >
                  {{ item.powerUpdateTime | dateFormat("yyyy-MM-dd hh:mm:ss") }}
                </div>
              </div>

              <div v-else-if="props.column.label === '上线时间'">
                <div
                  class="table-line"
                  :class="{
                    red: props.row.siteCeiling !== props.row.equipments.length,
                  }"
                  v-for="(item, index) in props.row.equipments"
                  :key="'equipmentOnlineTime' + index"
                >
                  {{ item.equipmentOnlineTime | dateFormat("yyyy-MM-dd") }}
                </div>
              </div>
              <div
                v-else-if="props.column.label === '操作'"
                style="display: flex"
              >
                <div
                  style="flex: 1"
                  v-if="props.row.equipments && props.row.equipments.length"
                >
                  <div
                    class="table-line-no-border"
                    v-for="(item, index) in props.row.equipments"
                    :key="'opra' + index"
                  >
                    <el-button
                      v-show="checkUserAuth(3, 19)"
                      @click="onDelEquipments(item, props.row)"
                      size="mini"
                      >删除
                    </el-button>
                  </div>
                </div>
                <div
                  class="handle_btns"
                  style="
                    flex: 1;
                    display: flex;
                    align-items: center;
                    margin-left: 12px;
                  "
                >
                  <div
                    v-show="checkUserAuth(3, 17)"
                    @click="onDelDevice(props.row)"
                  >
                    删除站点
                  </div>
                  <div
                    v-show="checkUserAuth(3, 111)"
                    @click="setSiteCenter(props.row.siteId)"
                    v-if="!props.row.isCenter"
                  >
                    设置中心点
                  </div>
                  <div
                    v-show="checkUserAuth(3, 98)"
                    v-if="!props.row.gpsRail && userLevel >= 2 && isAggregation"
                    @click="newSiteWl(props.row, false)"
                  >
                    绘制围栏
                  </div>
                  <div
                    v-show="checkUserAuth(3, 98)"
                    v-if="props.row.gpsRail && userLevel >= 2 && isAggregation"
                    @click="newSiteWl(props.row, true)"
                  >
                    修改围栏
                  </div>
                  <div
                    v-show="checkUserAuth(3, 115)"
                    @click="modifySiteInfo(props.row)"
                  >
                    修改站点信息
                  </div>
                  <div
                    v-show="checkUserAuth(3, 114)"
                    v-if="userLevel >= 2 && isAggregation"
                    @click="deleteWl(props.row)"
                  >
                    删除围栏
                  </div>
                </div>
              </div>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
          <div v-show="!checkUserAuth(3, 16)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>

    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="dialogWidth"
      :sureBtnText="sureBtnText"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure"
      :isShowFooter="false"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <div>
              站点名称：<span v-if="detail" style="margin-right: 32px">{{
                detail.siteName
              }}</span>
              道钉编号：<span v-if="equipmentPower">{{
                equipmentPower.equipmentNo
              }}</span>
            </div>
            <el-tab-pane label="更新记录" name="first">
              <w-table
                v-show="checkUserAuth(3, 20)"
                v-loading.body="tableLoadingPowerList"
                :data-list="tableDataPowerList"
                :columns="staticData.powerList.columns"
                :pageNo="formDataPowerList.pageNum"
                :pageSize="formDataPowerList.pageSize"
                :total="totalPowerList"
                @pageNoChange="pageNoChangePowerList"
                @pageSizeChange="pageSizeChangePowerList"
              >
                <template slot-scope="props" slot="cell">
                  <!-- <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span> -->
                  <div v-if="props.column.label === '更新方式'">
                    <span :class="{ green: props.row.type === 'app' }">{{
                      getTypeStatus(props.row.type)
                    }}</span>
                  </div>
                  <div v-else-if="props.column.label === '更新时间'">
                    <span>{{ props.row.createAt }}</span>
                  </div>
                  <span v-else>{{ props.row[props.column.property] }}</span>
                </template>
              </w-table>
              <div v-show="!checkUserAuth(3, 20)">
                您的账户没有权限查看此内容！
              </div>
            </el-tab-pane>
            <el-tab-pane label="变化曲线图" name="second">
              <div class="block text-right mtb10">
                <el-date-picker
                  v-show="checkUserAuth(3, 21) || checkUserAuth(3, 22)"
                  @change="dayChange"
                  v-model="day"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <!-- echarts -->
              <div id="echarts"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </w-dialog>
    <!-- w-dialog2 -->
    <w-dialog
      ref="w-dialog2"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleCloseExport"
      @handleCloseRight="handleCloseExport"
      @onSure="onSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选
          </el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              style="margin-bottom: 10px"
              v-for="city in deviceOptions"
              :label="city.key"
              :key="city.key"
              >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <div class="my_content_box">
      <div class="my_mask" v-show="dialogNewSiteVisible"></div>
      <div class="my_new_site_dialog" v-show="dialogNewSiteVisible">
        <div class="my_new_site_dialog_title">
          <div>新增站点围栏</div>
          <div style="cursor: pointer" @click="closeNewSiteMask">x</div>
        </div>
        <div id="newSiteMap"></div>
        <div class="right_box">
          <div class="right_box_item">
            <div class="right_box_item_label">站点名称:</div>
            <div class="right_box_item_value">
              <el-input
                v-model="siteName"
                size="mini"
                placeholder="请输入站点名称"
              ></el-input>
            </div>
          </div>
          <div class="right_box_item">
            <div class="right_box_item_label">站点单车上限:</div>
            <div class="right_box_item_value">
              <el-input-number
                v-model="siteBikeCeiling"
                size="mini"
                placeholder="请输入站点单车上限"
              ></el-input-number>
            </div>
          </div>
          <div class="right_box_item">
            <div class="right_box_item_label">站点编号(填一个五位数):</div>
            <div class="right_box_item_value site_id_area">
              <div class="site_id_area_front">{{ platformCode }}</div>
              <el-input
                v-model="siteId"
                :min="0"
                :max="49999"
                :maxlength="5"
                size="mini"
                placeholder="请输入站点编号(后五位)"
              ></el-input>
            </div>
            <div style="margin-top: 5px;color: red">
              <span>无特殊需求，请使用系统自动生成站点编号</span>
            </div>
          </div>
        </div>
        <div class="handle_btns">
          <el-button size="small" type="primary" @click="addSite"
            >添加</el-button
          >
          <el-button size="small" type="primary" @click="closeNewSiteMask"
            >取消</el-button
          >
        </div>
      </div>
    </div>
    <div class="my_content_box">
      <div class="my_mask" v-show="dialogModifyWlVisible"></div>
      <div class="my_new_site_dialog" v-show="dialogModifyWlVisible">
        <div class="my_new_site_dialog_title">
          <div>{{ isEdit ? "编辑" : "新增" }}围栏</div>
          <div style="cursor: pointer" @click="closeModifyResult">x</div>
        </div>
        <div id="myModifySiteMap"></div>
        <div class="map_handle_box">
          <div class="title">绘制站点围栏</div>
          <div class="map_handles">
            <div
              class="map_handle"
              v-if="!isEdit"
              :disabled="beginChartStatus"
              @click="beginChart"
            >
              绘制多边形
            </div>
            <div class="map_handle" @click="beginEditChart">开始编辑</div>
            <div class="map_handle" @click="endEditChart">结束编辑</div>
            <div class="map_handle" @click="clearPolygon">清除</div>
          </div>
        </div>
        <div>当前围栏的线段距离为：{{ line.join(",") }}</div>
        <div class="handle_btns">
          <el-button size="small" type="primary" @click="saveModifyResult"
            >保存</el-button
          >
          <el-button size="small" type="primary" @click="closeModifyResult"
            >取消</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogVisible == 1 ? '修改站点信息' : '批量设置'"
      :visible.sync="dialogVisible"
      width="50%"
      class="modify_site_main"
      :before-close="handleEditSiteClose"
      @opened="openSite"
    >
      <div>
        <div v-if="dialogVisible == 2">
          <div>
            当前已选择<a>{{ multipleSelection.length }}</a> 个站点
          </div>
          <div style="max-height: 184px" class="scrollbar">
            <p v-for="item in multipleSelection" :key="item.siteId">
              {{ item.siteName }}
            </p>
          </div>
        </div>
        <div class="modify_site_item" v-if="dialogVisible == 1">
          <div class="modify_site_item_label">站点名称：</div>
          <div class="modify_site_item_value">
            <el-input
              v-model="editSite.siteName"
              size="mini"
              placeholder="请输入站点名称"
            ></el-input>
          </div>
        </div>
        <div class="modify_site_item" v-if="dialogVisible == 1">
          <div class="modify_site_item_label">站点编号：</div>
          <div class="modify_site_item_value site_id_area">
            <div v-if="editSite.source == '0'">
              {{ editSite.siteFront + editSite.siteEnd }}
            </div>
            <div v-else class="modify_site_item_value site_id_area">
              <div class="site_front_area">{{ editSite.siteFront }}</div>
              <el-input
                type="text"
                v-model="editSite.siteEnd"
                size="mini"
                placeholder="请输入站点编号"
              ></el-input>
            </div>
          </div>
        </div>
       <el-checkbox-group v-model="checkList">
          <div class="modify_site_item">
            <el-checkbox label="siteBikeCeiling" v-if="dialogVisible == 2"></el-checkbox>
            <div class="modify_site_item_label">车位数：</div>
            <div class="modify_site_item_value">
              <div v-if="editSite.source == '0'||editSite.length">
                {{ editSite.siteBikeCeiling }}
              </div>
              <el-input-number
                v-else
                v-model="editSite.siteBikeCeiling"
                size="mini"
                placeholder="请输入车位数"
              ></el-input-number>
            </div>
          </div>
        <div class="modify_site_item" v-if="dialogVisible == 1">
          <div class="modify_site_item_label">站点长度：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.length }}
            </div>
            <el-input-number
              v-else
              v-model.number="editSite.length"
              size="mini"
              placeholder="请输入站点长度"
            ></el-input-number>
          </div>
        </div>
        <div class="modify_site_item" v-if="dialogVisible == 1">
          <div class="modify_site_item_label">是否回收站点：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.recycleSwitch == 1 ? "是" : "否" }}
            </div>
            <el-switch
              v-else
              size="mini"
              v-model="editSite.recycleSwitch"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </div>
        </div>
        <div class="modify_site_item">
          <el-checkbox label="brandPutSwitch" v-if="dialogVisible == 2"></el-checkbox>
          <div class="modify_site_item_label">是否可投放：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.brandPutSwitch == 1 ? "是" : "否" }}
            </div>
            <el-switch
              v-else
              size="mini"
              v-model="editSite.brandPutSwitch"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </div>
        </div>
        <div class="modify_site_item">
           <el-checkbox label="majorSwitch" v-if="dialogVisible == 2"></el-checkbox>
          <div class="modify_site_item_label">区域属性：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.majorSwitch == 1 ? "重点区域" : "一般区域" }}
            </div>
            <el-radio-group v-model="editSite.majorSwitch">
              <el-radio :label="0">一般区域</el-radio>
              <el-radio :label="1">重点区域</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="modify_site_item">
           <el-checkbox label="dispatchThresholdMore" v-if="dialogVisible == 2"></el-checkbox>
          <div class="modify_site_item_label">偏多调度阀值：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.dispatchThresholdMore }}
            </div>
            <el-input-number
              v-else
              v-model="editSite.dispatchThresholdMore"
              size="mini"
              placeholder="请输入"
            ></el-input-number>
            <span>注：达到调度任务触发条件通知单车企业进行调度</span>
          </div>
        </div>
        <div class="modify_site_item">
            <el-checkbox label="dispatchThresholdLess" v-if="dialogVisible == 2"></el-checkbox>
          <div class="modify_site_item_label">偏少调度阀值：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.dispatchThresholdLess }}
            </div>
            <el-input-number
              v-else
              v-model="editSite.dispatchThresholdLess"
              size="mini"
              placeholder="请输入"
            ></el-input-number>
            <span>注：达到调度任务触发条件通知单车企业进行调度</span>
          </div>
        </div>
        <div class="modify_site_item">
           <el-checkbox label="dispatchResponseMinute" v-if="dialogVisible == 2"></el-checkbox>
          <div class="modify_site_item_label">调度响应时间：</div>
          <div class="modify_site_item_value">
            <div v-if="editSite.source == '0'">
              {{ editSite.dispatchResponseMinute }}
            </div>
            <el-input-number
              v-else
              v-model="editSite.dispatchResponseMinute"
              size="mini"
              placeholder="请输入"
            ></el-input-number>
            <span class="time">分钟</span>
          </div>
        </div>
        <div class="modify_site_item" v-if="dialogVisible == 1">
          <div class="modify_site_item_label">站点经纬度定位</div>
        </div>
          </el-checkbox-group>
        <div v-if="dialogVisible == 1">
          <div id="sitemap"></div>
        </div>
      </div>
      <div class="my_dialog-footer">
        <el-button @click="handleEditSiteClose" size="small">取 消</el-button>
        <el-button type="primary" @click="makeSureToModify" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import configJs from '../index'
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
import WSearchs from '@/components/Searchs/index.vue'
import staticData from '../staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'
import {
  compare,
  getFilterParams,
  dateFormat,
  getDistance,
  downloadExcel
} from '@/utils/tools'
import echarts from 'echarts'
import store from '../../../store'

var map = null
var modifyMap = null
var _this = null
var polygon = null
var polyEditor = null
export default {
  name: 'deviceManagement',
  components: {
    WDialog,
    WTable,
    WSearchs
  },
  data() {
    return {
      checkList: [],
      multipleSelection: [],
      line: [],
      siteName: '', // 创建新站点弹窗的站点名称
      siteBikeCeiling: '', // 创建新站点弹窗的站点单车上限
      siteCeiling: '', // 创建新站点弹窗的站点设备上限
      siteLat: '', // 创建新站点弹窗的站点纬度
      siteLon: '', // 创建新站点弹窗的站点经度
      siteId: 0, // 创建新站点弹窗的站点编号-后五位不要大于50000
      editSite: {}, // 编辑的站点信息
      pointArr: [], // 用来记录围栏的集合
      nearBySite: [], // 附近的虚拟站点
      dialogVisible: false,
      dialogNewSiteVisible: false,
      beginChartStatus: false,
      dialogModifyWlVisible: false,
      isEdit: false,
      wlEditRow: {}, // 修改围栏的对象
      formData: {
        pageNum: 1,
        pageSize: 100
      },
      pageSizes: [100, 200, 500],
      total: 0,
      deviceTotal: 0,
      totalRole: 0,
      tableLoading: false,
      tableData: null,
      type: '',
      dialogTitle: '电池电量详情',
      dialogWidth: '60%',
      sureBtnText: '确定',
      detail: null,
      searchData: null,
      equipmentPower: null,
      totalPowerList: 0,
      formDataPowerList: {
        pageNum: 1,
        pageSize: 10
      },
      activeName: 'first',
      tableDataPowerList: null,
      tableLoadingPowerList: false,
      day: '',
      charts: '',
      // 导出
      deviceOptions: [
        {
          key: 1,
          label: '站点名称'
        },
        {
          key: 2,
          label: '站点编号'
        },
        {
          key: 3,
          label: '经度'
        },
        {
          key: 4,
          label: '纬度'
        },
        {
          key: 12,
          label: '车位数'
        },
        {
          key: 13,
          label: '创建时间'
        },
        {
          key: 14,
          label: '围栏数组'
        },
        {
          key: 15,
          label: '投放权限'
        },
        {
          key: 17,
          label: '调度响应时间'
        },
        {
          key: 18,
          label: '区域属性'
        },
        {
          key: 19,
          label: '偏多阈值'
        },
        {
          key: 20,
          label: '偏少阈值'
        },
        {
          key: 21,
          label: '站点长度'
        }
      ],
      checkedCities: [],
      isIndeterminate: true,
      checkAll: false,
      tableViewHeight: '',
      // 禁行区 / 禁停区
      configJs: configJs,
      x: 1// 长度系数
    }
  },
  computed: {
    ...mapGetters([
      'areaAll',
      'isAggregation',
      'userLevel',
      'platformCode',
      'user',
      'selfAreaId',
      'permissions',
      'authorization',
      'userSelfAreaId',
      'globaleSelfAreaId'
    ]),
    staticData() {
      return staticData
    },
    currTab() {
      return this.configJs.find((item) => item.active)
    }
  },
  created() {
    if (Object.keys(this.$route.params).length == 1) {
      this.initData()
    }
    // this.initRole()
    this.day = [new Date(this.getWeekBefore()), new Date(this.getToday())]
  },
  mounted() {
    _this = this
    map = new AMap.Map('newSiteMap', {
      resizeEnable: true, // 允许缩放
      zoom: 15 // 设置地图的缩放级别，0 - 20
    })
    map.on('click', function (ev) {
      // 触发事件的地理坐标，AMap.LngLat 类型
      var lnglat = ev.lnglat
      console.log('当前选中：', lnglat.getLng(), '----', lnglat.getLat())
      _this.siteLon = lnglat.getLng()
      _this.siteLat = lnglat.getLat()
      // 清除原有marker
      map.clearMap()
      // 创建一个 Marker 实例：
      var marker = new AMap.Marker({
        position: new AMap.LngLat(lnglat.getLng(), lnglat.getLat()) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })

      // 将创建的点标记添加到已有的地图实例：
      map.add(marker)
    })
    modifyMap = new AMap.Map('myModifySiteMap', {
      resizeEnable: true, // 允许缩放
      zoom: 15 // 设置地图的缩放级别，0 - 20
    })
    modifyMap.on('click', function (ev) {
      console.log(
        '您在[ ' +
          ev.lnglat.getLng() +
          ',' +
          ev.lnglat.getLat() +
          ' ]的位置点击了地图！'
      )
      if (!_this.isEdit) {
        // 触发事件的对象
        if (!(_this.pointArr && _this.pointArr.length)) {
          // 已经点击了绘制的情况下，会给地图当前位置创建一个默认图层
          // 多边形轮廓线的节点坐标数组
          const lng = ev.lnglat.getLng()
          const lat = ev.lnglat.getLat()
          var path = [
            new AMap.LngLat(lng, lat),
            new AMap.LngLat(lng + 0.0005, lat),
            new AMap.LngLat(lng + 0.0005, lat + 0.0001),
            new AMap.LngLat(lng, lat + 0.0001)
          ]

          polygon = new AMap.Polygon({
            path: path,
            strokeColor: '#FF33FF',
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
            fillColor: '#1791fc',
            zIndex: 50
          })

          // 初始化围栏
          _this.pointArr = []
          var b = polygon.getPath()
          for (var d = 0; d < b.length; d++) {
            _this.pointArr.push({
              lat: parseFloat(b[d].lat),
              lon: parseFloat(b[d].lng)
            })
          }
          _this.calcWlDistance(_this.pointArr)
          modifyMap.add(polygon)
          modifyMap.setFitView([polygon])
          polyEditor = new AMap.PolyEditor(modifyMap, polygon)

          polyEditor.on('addnode', function (event) {
            console.log(event.target.getPath(), '--event.addnode---')
          })

          polyEditor.on('adjust', function (event) {
            console.log(
              JSON.stringify(event.target.getPath()),
              '--event.adjust---'
            )
            _this.pointArr = []
            var a = event.target.getPath()
            for (var q = 0; q < a.length; q++) {
              _this.pointArr.push({
                lat: parseFloat(a[q].lat),
                lon: parseFloat(a[q].lng)
              })
            }
            console.log(_this.pointArr, '--_this.pointArr--')
            _this.calcWlDistance(_this.pointArr)
          })

          polyEditor.on('removenode', function (event) {
            console.log(
              JSON.stringify(event.target.getPath()),
              '--event.removenode---'
            )
          })

          polyEditor.on('end', function (event) {
            // event.target 即为编辑后的多边形对象
            console.log(event.target.getPath(), '--event.target---')
          })
          _this.beginChartStatus = false
        } else {
          _this.$message.warning('一次仅能创建一个围栏')
        }
      }
    })
  },
  methods: {
    selectionChange(e) {
      this.multipleSelection = e
      // if (e && e.length) {
      //   e.forEach((item) => {
      //     this.multipleSelection.push(item.id)
      //   })
      // }
    },
    treeToList(tree, result = []) {
      tree.forEach((node) => {
        result.push(node)
        node.child && this.treeToList(node.child, result)
      })
      return result
    },
    tabChange(item) {
      // console.log(item)
      this.configJs.forEach((item) => (item.active = false))
      const currTab = this.configJs.find((it) => +it.id === +item.id)
      currTab.active = true
    },
    saveModifyResult() {
      const data = {
        siteId: this.wlEditRow.siteId,
        gpsRail: JSON.stringify(this.pointArr)
      }
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId
      }
      Api.addSiteArea(data, params)
        .then((res) => {
          console.log(res)
          if (res.code === 200) {
            // 删除成功
            this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
            this.closeModifyResult()
            this.onSearch(this.searchData)
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    closeModifyResult() {
      _this.pointArr = []
      polygon = null
      polyEditor && polyEditor.close()
      polyEditor = null
      this.dialogModifyWlVisible = false
    },
    openSite() {
      if (this.dialogVisible == 2) {
        this.checkList = []
        return
      }
      const map = new AMap.Map('sitemap', {
        resizeEnable: true, // 允许缩放
        zoom: 15, // 设置地图的缩放级别，0 - 20
        center: [_this.editSite.siteLon, _this.editSite.siteLat],
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false
      })
      if (this.editSite.gpsRail) {
        console.log(this.editSite.gpsRail, '----site.gpsRail-----')
        const gps = JSON.parse(this.editSite.gpsRail)
        const path = []
        for (const b of gps) {
          path.push(new AMap.LngLat(b.lon, b.lat))
        }

        map.add(
          new AMap.Polygon({
            path: path,
            strokeColor: '#FF33FF',
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
            fillColor: '#1791fc',
            zIndex: 50
          })
        )
      }
      const marker = new AMap.Marker({
        position: [_this.editSite.siteLon, _this.editSite.siteLat],
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
        imageSize: new AMap.Size(26, 34),
        // 设置是否可以拖拽
        draggable: true,
        cursor: 'move',
        anchor: 'center',
        // 设置拖拽效果
        raiseOnDrag: true
      })
      marker.on('dragend', function ({ lnglat }) {
        Api.updateSiteGps({
          selfAreaId: _this.selfAreaId,
          site_id: _this.editSite.siteId,
          lat: lnglat.lat,
          lon: lnglat.lng
        })
          .then((res) => {
            if (res.code === 200) {
              // 删除成功
              _this.$message.success('修改站点坐标成功')
            } else {
              _this.$message.warning(res && res.message)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      })
      marker.setMap(map)
    },
    makeSureToModify() {
      console.log(_this.editSite)
      let params = {}
      let url = ''
      if (this.dialogVisible == 1) {
        params = {
          selfAreaId: _this.selfAreaId,
          originSiteId: _this.editSite.siteId,
          siteName: _this.editSite.siteName,
          recycleSwitch: _this.editSite.recycleSwitch,
          majorSwitch: _this.editSite.majorSwitch,
          brandPutSwitch: _this.editSite.brandPutSwitch,
          length: _this.editSite.length,
          dispatchResponseMinute: _this.editSite.dispatchResponseMinute,
          dispatchThresholdLess: _this.editSite.dispatchThresholdLess,
          dispatchThresholdMore: _this.editSite.dispatchThresholdMore
        }
        if (this.editSite.source != '0') {
          params = {
            ...params,
            ...{
              siteId: _this.editSite.siteFront + this.editSite.siteEnd,
              siteBikeCeiling: _this.editSite.siteBikeCeiling
            }
          }
        }
        url = Api.modifySiteInfo
      } else {
        if (this.checkList.length == 0) {
          this.$message.warning('请至少勾选一项')
          return
        }
        params = {
          siteIds: this.multipleSelection
            .map((val) => {
              return val.siteId
            })
            .join(','),
          selfAreaId: _this.selfAreaId
        }
        for (const val of this.checkList) {
          params[val] = _this.editSite[val]
        }
        url = Api.multModifySite
      }
      url(params)
        .then((res) => {
          console.log(res)
          if (res.code === 200) {
            // 删除成功
            _this.handleEditSiteClose()
            _this.onSearch(_this.searchData)
            _this.$message.success('编辑成功')
          } else {
            _this.$message.warning(res && res.message)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    handleEditSiteClose() {
      this.dialogVisible = false
      this.editSite = {}
    },
    formatZero(num, len) {
      if (String(num).length > len) return num
      return (Array(len).join(0) + num).slice(-len)
    },
    onblurFunc(e) {
      if (e.target.value.length < 5) {
        _this.siteId = _this.formatZero(e.target.value, 5)
      } else {
        _this.siteId = e.target.value.substring(0, 5)
      }

      console.log(e.target.value)
    },
    addSite() {
      const reg = /^\d{1,}$/
      if (this.siteId.toString().length === 5) {
        if (!reg.test(this.siteId)) {
          this.$message.warning('只能输入5位的数字！')
          return
        }
      } else {
        this.$message.warning('必须输入5位的数字！')
        return
      }
      if (this.siteId > 49999) {
        this.siteId = 49999
      }
      const params = {
        selfAreaId: this.selfAreaId,
        selectAreaId: this.selfAreaId,
        siteName: this.siteName,
        siteBikeCeiling: this.siteBikeCeiling,
        siteCeiling: '0',
        siteLat: this.siteLat,
        siteLon: this.siteLon,
        siteId: this.platformCode + this.siteId
      }
      Api.setSite(params)
        .then((res) => {
          console.log(res)
          if (res.code === 200) {
            // 删除成功
            this.closeNewSiteMask()
            this.$message.success('添加成功')

            this.onSearch(_this.searchData)
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    closeNewSiteMask() {
      // 关闭新建站点弹窗
      this.dialogNewSiteVisible = false
      map.clearMap()
      this.siteName = '' // 创建新站点弹窗的站点名称
      this.siteBikeCeiling = '' // 创建新站点弹窗的站点单车上限
      this.siteCeiling = '' // 创建新站点弹窗的站点设备上限
      this.siteLat = '' // 创建新站点弹窗的站点纬度
      this.siteLon = '' // 创建新站点弹窗的站点经度
      this.siteId = 0 // 创建新站点弹窗的站点编号-后五位不要大于50000
    },
    // 获取具体区域站点信息最大的站点编号
    getVirtualMaxSiteId() {
      Api.getMaxSiteId(this.selfAreaId, 1).then((res) => {
        if (res.code === 200) {
          this.siteId = res.data
        }
      }).catch((e) => {
        console.log('获取具体区域站点信息最大的站点编号异常' + e)
      })
    },
    getArea(adds, id) {
      const target = adds.find((item) => item.id === id)
      if (target && target.parentId) {
        const p = adds.find((item) => item.id === target.parentId)
        return p.areaName + target.areaName
      }
      return target.areaName
    },
    async newSite() {
      // 点击新增站点按钮
      this.closeNewSiteMask()
      this.dialogNewSiteVisible = true
      this.getVirtualMaxSiteId()
      const list = this.treeToList(this.areaAll)
      const address = this.getArea(list, this.selfAreaId)
      // 根据地名定位
      AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder()
        geocoder.getLocation(address, async function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 经纬度
            var lng = result.geocodes[0].location.lng
            var lat = result.geocodes[0].location.lat
            console.log('lng', lng, ', lat', lat)

            await _this.queryFictitiousSite()
            console.log(_this.nearBySite, '--vm.nearBySite---')
            _this.nearBySite.forEach((site) => {
              if (site.gpsRail) {
                console.log(site.gpsRail, '----site.gpsRail-----')
                const gps = JSON.parse(site.gpsRail)
                const path2 = []
                for (const b of gps) {
                  path2.push(new AMap.LngLat(b.lon, b.lat))
                }

                map.add(
                  new AMap.Polygon({
                    path: path2,
                    strokeColor: '#FF33FF',
                    strokeWeight: 6,
                    strokeOpacity: 0.2,
                    fillOpacity: 0.4,
                    fillColor: '#1791fc',
                    zIndex: 50
                  })
                )
              }
            })

            map.setCenter(new AMap.LngLat(lng, lat))
          } else {
            console.log('定位失败！')
          }
        })
      })
    },
    // 关闭新增站点弹窗
    handleNewSiteClose() {},
    // 删除围栏
    deleteWl(row) {
      const _this = this

      this.$confirm('确定删除该围栏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(row.siteId)
          const data = {
            siteId: row.siteId,
            gpsRail: null
          }
          const params = {
            selfAreaId: _this.selfAreaId,
            areaId: _this.selfAreaId
          }
          Api.addSiteArea(data, params)
            .then((res) => {
              console.log(res)
              if (res.code === 200) {
                // 删除成功
                _this.$message.success('删除成功')
                _this.onSearch(_this.searchData)
              } else {
                _this.$message.warning(res && res.message)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    modifySiteInfo(row) {
      // 修改站点信息
      console.log(row)
      this.editSite = { ...row }
      this.editSite.siteBikeCeiling = Math.floor(this.editSite.length / this.x)
      this.editSite.siteFront = row.siteId.substring(0, 8)
      this.$set(this.editSite, 'siteEnd', row.siteId.substring(8))
      this.dialogVisible = 1 // 1是单个设置
    },
    multSet() {
      if (this.multipleSelection.length == 0) {
        return
      }
      this.dialogVisible = 2 // 2是批量设置
    },
    async queryFictitiousSite() {
      const vm = this
      const params = {
        source: 1,
        selfAreaId: this.selfAreaId,
        userId: this.user.id,
        currentPage: 1,
        pageSize: 100000
      }
      await Api.getDeviceList(params)
        .then((res) => {
          if (res.code === 200) {
            console.log(res.data.lists, '--res.data.lists---')
            vm.nearBySite = res.data.lists
            // vm.tableData.forEach(item => {
            //   if (item.equipments && item.equipments.length) {
            //     item.equipments.sort(this.compare('equipmentNo'))
            //   }
            // })
            // vm.total = res.data.total
            // vm.deviceTotal = res.data.pageSize
          } else {
            // vm.$message.warning(res.message)
          }
          vm.tableLoading = false
          vm.calcView()
        })
        .catch((err) => {
          vm.tableLoading = false
          console.log(err)
        })
    },
    makeEnclosure(pointList) {
      var path = []
      _this.calcWlDistance(pointList)
      for (const i of pointList) {
        path.push(new AMap.LngLat(i.lon, i.lat))
        this.pointArr.push({
          lat: i.lat,
          lon: i.lon
        })
      }

      polygon = new AMap.Polygon({
        path: path,
        strokeColor: '#FF33FF',
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        fillColor: '#1791fc',
        zIndex: 50
      })

      var m3 = new AMap.Marker({
        position: [_this.wlEditRow.siteLon, _this.wlEditRow.siteLat]
      })
      modifyMap.add(polygon)
      modifyMap.setFitView([m3])
      polyEditor = new AMap.PolyEditor(modifyMap, polygon)

      polyEditor.on('addnode', function (event) {
        console.log(event.target.getPath(), '--event.addnode---')
      })

      polyEditor.on('adjust', function (event) {
        console.log(
          JSON.stringify(event.target.getPath()),
          '--event.adjust---'
        )
        _this.pointArr = []
        var a = event.target.getPath()
        for (var q = 0; q < a.length; q++) {
          _this.pointArr.push({
            lat: parseFloat(a[q].lat),
            lon: parseFloat(a[q].lng)
          })
        }
        console.log(_this.pointArr, '--_this.pointArr--')
        _this.calcWlDistance(_this.pointArr)
      })

      polyEditor.on('removenode', function (event) {
        console.log(
          JSON.stringify(event.target.getPath()),
          '--event.removenode---'
        )
      })

      polyEditor.on('end', function (event) {
        // event.target 即为编辑后的多边形对象
        console.log(event.target.getPath(), '--event.target---')
      })
    },
    newSiteWl(row, isEdit) {
      console.log(row, isEdit)
      this.isEdit = isEdit
      modifyMap.clearMap()
      var marker = new AMap.Marker({
        position: new AMap.LngLat(row.siteLon, row.siteLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        anchor: 'center'
      })

      // 将创建的点标记添加到已有的地图实例：
      modifyMap.add(marker)
      this.wlEditRow = row
      this.pointArr = []
      if (isEdit) {
        // 编辑围栏
        this.makeEnclosure(JSON.parse(row.gpsRail))
      } else {
        // 新增围栏
        this.line = []
        // this.newSetWl(JSON.parse(row.gpsRail));
      }
      this.dialogModifyWlVisible = true
      modifyMap.setCenter(new AMap.LngLat(row.siteLon, row.siteLat))
    },
    // 设置中心点
    setSiteCenter(siteId) {
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId,
        siteId: siteId
      }
      Api.putAreaCenter(params).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.onSearch(_this.searchData)
        } else {
          this.$message.warning(res && res.message)
        }
      })
    },
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        // 30: tab修正
        this.tableViewHeight = window.innerHeight - 56 - H - 79 - 30
      })
    },
    renderHeaderBySiteId(h, { column }) {
      // h即为cerateElement的简写，具体可看vue官方文档
      return h('div', [
        h('p', column.label),
        h('span', '(' + this.total + ')')
      ])
    },
    renderHeaderBySiteCeiling(h, { column }) {
      return h('div', [
        h('p', column.label),
        h('span', '(' + this.deviceTotal + ')')
      ])
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedCities = val ? this.deviceOptions.map((it) => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.deviceOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.deviceOptions.length
    },
    handleCloseExport() {
      this.checkedCities = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-dialog2'].onCloseDialog()
    },
    showWdialog2(params) {
      if (params) {
        this.searchData = params
      }
      this.$refs['w-dialog2'].onShowDialog()
    },
    // 确认导出
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: vm.selfAreaId
      }
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.userId = vm.user.id
      data.export =
        vm.checkedCities && vm.checkedCities.length
          ? vm.checkedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      Api.downDeviceList(data, params).then((res) => {
        if (res.code === 200) {
          downloadExcel(res.data)
          vm.tableLoading = false
          vm.handleCloseExport()
        } else {
          vm.$message.warning(res.message)
        }
        vm.tableLoading = false
      })
    },
    dayChange(date) {
      const vm = this
      const beginDay = vm.getToday(date[0])
      const endDay = vm.getToday(date[1])
      const durationDay = vm.getEveryDateStr(beginDay, endDay)
      console.log(beginDay, endDay, durationDay)
      vm.initEquipmentPowerBetween(beginDay, endDay)
    },
    handleClick(tab, event) {
      if (this.activeName === 'second') {
        const beginDay = this.getToday(this.day[0])
        const endDay = this.getToday(
          new Date(this.getToday(this.day[1])).getTime() +
            (23 * 60 * 60 + 59 * 60 + 59) * 1000
        )
        this.initEquipmentPowerBetween(beginDay, endDay)
      }
    },
    initEquipmentPowerBetween(beginDay, endDay) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }

      if (beginDay === endDay) {
        const oneData = {
          equipmentMac: vm.equipmentPower.equipmentMac,
          day: beginDay
        }
        Api.getEquipmentPowerOne({
          ...oneData,
          ...params
        }).then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length) {
              const avgTime = []
              const avgPower = []
              res.data.forEach((item) => {
                avgTime.push(item.avgTime)
                avgPower.push(item.avgPower)
              })
              const options = this.getDrawLineParams(avgTime, avgPower)
              vm.drawLine('echarts', options)
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
      } else {
        const data = {
          equipmentMac: vm.equipmentPower.equipmentMac,
          startDay: beginDay,
          endDay: endDay
        }
        Api.getEquipmentPowerBetween({
          ...data,
          ...params
        }).then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length) {
              const avgTime = []
              const avgPower = []
              res.data.forEach((item) => {
                avgTime.push(item.avgTime)
                avgPower.push(item.avgPower)
              })
              const options = this.getDrawLineParams(avgTime, avgPower)
              vm.drawLine('echarts', options)
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
      }
    },
    drawLine(id, options) {
      console.log(id, options)
      this.charts = echarts.init(document.getElementById(id))
      this.charts.setOption({
        ...options,
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '2%',
          containLabel: true
        },

        toolbox: {
          feature: {
            saveAsImage: {}
          }
        }
      })
    },
    getDrawLineParams(avgTime, avgPower) {
      const options = {
        legend: {
          data: ['电量趋势']
        },
        // x抽
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: avgTime, // this.getEveryDateStr(this.getWeekBefore(), this.
          // x轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18
          }
        },
        // y轴
        yAxis: {
          type: 'value',
          name: '电量趋势(%)', // y轴名称
          // y轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18,
            marginRight: 30
          },
          splitLine: {
            // 网格线
            lineStyle: {
              type: 'dashed' // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true // 隐藏或显示
          }
        },
        series: [
          {
            name: '电量趋势(%)',
            type: 'line',
            stack: '总量',
            data: avgPower, // ['3', '2', '4', '4', '5', '100', '500'],
            color: '#1F8FFB'
          }
        ]
      }
      return options
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate()
      )
    },
    getWeekBefore() {
      // 返回 '2020-08-07'
      const day1 = new Date()
      day1.setTime(day1.getTime() - 7 * 24 * 60 * 60 * 1000)
      return (
        day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
      )
    },
    getEveryDateStr(begin, end) {
      // 返回 日期的数组 如 ['2020-08-07',...,'2020-08-14']
      var arr = []
      var ab = begin.split('-')
      var ae = end.split('-')
      var db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      var de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000
      // console.log(unixDb, unixDe)
      for (var k = unixDb; k <= unixDe;) {
        // console.log((new Date(parseInt(k))).format());
        k = k + 24 * 60 * 60 * 1000
        arr.push(dateFormat(parseInt(k)))
      }
      return arr
    },
    getTypeStatus(type) {
      let str = ''
      switch (type) {
        case 'app':
          str = '蓝牙道钉APP'
          break
        case 'ret':
          str = '租车还车'
          break
        case 'miniprogram':
          str = '嗅探巡查'
          break
      }
      return str
    },
    onShowDialog(item, detail) {
      this.equipmentPower = item
      this.detail = detail
      this.getEquipmentPowerList()
    },
    getEquipmentPowerList() {
      const vm = this
      const params = {}
      vm.tableLoadingPowerList = true
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.formDataPowerList.pageNum
      params.pageSize = this.formDataPowerList.pageSize
      params.equipmentMac = this.equipmentPower.equipmentMac
      Api.getEquipmentPowerList(params).then((res) => {
        if (res.code === 200) {
          vm.tableDataPowerList = res.data.lists
          vm.totalPowerList = res.data.total
          vm.$refs['w-dialog'].onShowDialog()
        } else {
          vm.$message.warning(res.message)
        }
        vm.tableLoadingPowerList = false
      })
    },
    onSure() {
      console.log('onSure')
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          successFn && successFn.call(this)
        })
        .catch(() => {
          failFn && failFn.call(this)
        })
    },
    onDelEquipments(item, detail) {
      this.equipmentPower = item
      this.detail = detail
      this.showConfirm(
        '温馨提示',
        '你是否确定删除“' + detail.siteName + '”的' + item.equipmentNo + '道',
        () => {
          this.handleDelEquipments()
        },
        () => {
          this.handleClose()
        }
      )
    },
    handleDelEquipments(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        equipmentMac: this.equipmentPower.equipmentMac
      }
      const data = {
        equipmentMac: this.equipmentPower.equipmentMac
      }
      Api.deleteEquipment(data, params).then((res) => {
        if (res.code === 200) {
          vm.$message.success('蓝牙道钉删除成功！')
          vm.initData()
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    refreshAddress() {
      const vm = this
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId
      }
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId
      store
        .dispatch('user/setSideBarLoading', {
          value: true
        })
        .then(() => vm.noon)
      store.dispatch('user/getUserArea2', params).then(() => {
        store
          .dispatch('user/setSideBarLoading', {
            value: false
          })
          .then(() => vm.noon)
      })
      // if (Number(vm.globaleSelfAreaId)) { // 非 000000
      //   params.areaId = vm.globaleSelfAreaId
      //   store.dispatch('user/getUserArea2', params).then(() => vm.noon)
      // } else { // 000000
      //   store.dispatch('user/getAreaAll', params).then(() => vm.noon)
      // }
    },
    noon() {},
    onDelDevice(item) {
      this.detail = item
      this.showConfirm(
        '温馨提示',
        '你是否确定删除“' + item.siteName + '”站点？',
        () => {
          this.handleDelDevice(item)
        },
        () => {
          this.handleClose()
        }
      )
    },
    handleDelDevice(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      const data = {
        siteId: this.detail.siteId,
        areaId: this.detail.areaId
      }
      Api.deleteDeviceSite(data, params).then((res) => {
        if (res.code === 200) {
          vm.$message.success('站点删除成功！')
          vm.initData()
          // vm.refreshAddress()
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    // 开始绘制
    beginChart() {
      if (!this.beginChartStatus) {
        this.beginChartStatus = true
      }
    },
    beginEditChart() {
      polyEditor && polyEditor.open()
    },
    calcWlDistance(pointList) {
      console.log(pointList, 'pointList')
      const arr = []
      if (pointList && pointList.length) {
        for (let b = 0; b <= pointList.length - 1; b++) {
          if (b == pointList.length - 1) {
            arr.push(
              getDistance(
                pointList[b].lat,
                pointList[b].lon,
                pointList[0].lat,
                pointList[0].lon
              )
            )
          } else {
            arr.push(
              getDistance(
                pointList[b].lat,
                pointList[b].lon,
                pointList[b + 1].lat,
                pointList[b + 1].lon
              )
            )
          }
        }
      }
      this.line = [...arr]
    },
    endEditChart() {
      polyEditor && polyEditor.close()
    },
    clearPolygon() {
      polygon && polygon.hide()
      this.pointArr = []
    },
    onSearch(params) {
      console.log('onSearch', params)
      this.searchData = params
      this.initData(true)
    },
    initData(type) {
      const vm = this
      vm.tableLoading = true
      let params = {}
      if (this.searchData) {
        params = {
          ...this.searchData
        }
      }
      if (type) {
        this.formData.pageNum = 1
      }
      params.selfAreaId = this.selfAreaId
      params.userId = this.user.id
      params.currentPage = this.formData.pageNum
      params.pageSize = this.formData.pageSize
      params = getFilterParams(params)
      Api.getFactor(this.selfAreaId).then(({ data }) => {
        this.x = data.data || null
      })
      Api.getDeviceList(params)
        .then((res) => {
          if (res.code === 200) {
            vm.tableData = res.data.lists
            vm.tableData.forEach((item) => {
              if (item.equipments && item.equipments.length) {
                item.equipments.sort(this.compare('equipmentNo'))
              }
            })
            vm.total = res.data.total
            vm.deviceTotal = res.data.pageSize
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
          vm.calcView()
        })
        .catch((err) => {
          vm.tableLoading = false
          console.log(err)
        })
    },
    compare(property) {
      return function (a, b) {
        if (a[property] && b[property]) {
          return a[property].charCodeAt() - b[property].charCodeAt()
        }
      }
    },
    handleClose(bo) {
      this.handleCloseBtn()
    },
    handleCloseBtn() {
      this.detail = null
      this.equipmentPower = null
      this.type = ''
      this.activeName = 'first'
      this.day = [new Date(this.getWeekBefore()), new Date(this.getToday())]
      this.formDataPowerList.pageNum = 1
      this.formDataPowerList.pageSize = 10
      this.charts && this.charts.dispose()

      this.$refs['w-dialog'].onCloseDialog()
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    pageNoChangePowerList(page) {
      this.formDataPowerList.pageNum = page
      this.getEquipmentPowerList()
    },
    pageSizeChangePowerList(size) {
      this.formDataPowerList.pageSize = size
      this.getEquipmentPowerList()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/index.less";
.modify_site_main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .el-checkbox{
    /deep/.el-checkbox__label{
      display: none;
    }
  }
  .my_dialog-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .scrollbar {
    height: 184px;
    width: 70%;
    overflow-y: auto;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 8px 10px;
    margin-top: 6px;
    margin-bottom: 24px;
  }
  .modify_site_item {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    align-items: center;
    .el-input-number {
      width: 180px !important;
      & + span {
        color: rgba(0, 0, 0, 0.25);
        margin-left: 6px;
        line-height: 28px;
        &.time {
          color: rgba(0, 0, 0, 0.65);
          color: 14px;
        }
      }
    }
    &_label {
      min-width: 100px;
      text-align: right;
      font-size: 14px;
    }
    .site_front_area {
      font-size: 12px;
      width: 100px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      background: #d9d9d9;
      text-align: center;
      justify-content: center;
      border: 1px solid #d9d9d9;
    }
    &_value {
      display: flex;
      font-size: 14px;
    }
  }
}
.my_content_box {
  position: relative;

  .my_mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1006;
    background: rgba(0, 0, 0, 0.5);
  }

  .my_new_site_dialog {
    position: fixed;
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    left: 30px;
    right: 30px;
    bottom: 30px;
    top: 30px;
    z-index: 1007;
    background: #fff;

    &_title {
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
    }

    .right_box {
      position: absolute;
      padding: 10px;
      box-sizing: border-box;
      right: 0;
      top: 30px;
      width: 300px;
      height: calc(100% - 30px);
      background: #fff;

      .right_box_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 20px;

        &_label {
          min-width: 100px;
          text-align: left;
        }

        &_value {
          margin-top: 10px;
        }

        .site_id_area {
          display: flex;
          justify-content: center;
          flex-direction: row;
          align-items: center;

          .site_id_area_front {
            border: 1px solid #dcdfe6;
            height: 28px;
            line-height: 28px;
            box-sizing: border-box;
            border-right: 0;
            padding: 0 10px;
            border-bottom-left-radius: 4px;
            border-top-left-radius: 4px;
          }
        }
      }
    }

    .handle_btns {
      height: 40px;

      line-height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .map_handle_box {
    position: absolute;
    border-radius: 5px;
    right: 50px;
    bottom: 100px;
    width: 124px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;

    .map_handles {
      margin-top: 10px;

      .map_handle {
        cursor: pointer;
        border-radius: 12px;
        border: 1px solid #1f8ffb;
        color: #1f8ffb;
        padding: 2px 5px;
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
}

#newSiteMap {
  height: 90%;
}
#myModifySiteMap {
  height: 85%;
}
#sitemap {
  width: 400px;
  height: 160px;
}
.handle_btns {
  display: flex;
  flex-direction: column;
  color: #1f8ffb;
  justify-content: center;

  > div {
    cursor: pointer;
  }
}

.red {
  color: red;
}

.red-r {
  color: red;
}

.device-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

#echarts {
  width: 780px;
  height: 400px;
}
.dialog-content {
  .content-header {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;

    .title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 16px;
    }

    .author {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.45);

      span {
        margin-right: 32px;
      }
    }
  }

  .content-body {
    padding: 16px 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.45);
  }
}

.table-line,
.table-line-no-border {
  height: 50px;
  line-height: 50px;
}

.table-line + .table-line {
  border-top: 1px solid #ebebeb;
}

.device /deep/.el-table {
  td:first-child,
  tr:first-child {
    .cell {
      padding-right: 0;
      padding-left: 14px;
    }
  }
}
</style>
